import React from "react";
import "./Checkpoint.css";

const ActiveStats = ({ checkpointID }) => {
  return (
    <div className="active_stats_container">
        <div className="active_stats_left_block">
            <div className="active_stats_block" style={{justifyContent : "flex-start"}}>
                <div className="status-pointer"></div>
                <label>Live weighbridge Active</label>
            </div>
            <div className="active_stats_block">
                <label>Avg Weight :</label>
                <span>120</span>
            </div>
             <div className="active_stats_block">
                <label>Peak Hours : </label>
                <span>120</span>
            </div>
        </div>
        <div className="active_stats_left_block">
            <div className="active_stats_right_block">
                <label>Last updated 1 min ago</label>
            </div>
        </div>
        
    </div>
  );
};

export default React.memo(ActiveStats);